import {
  USER_INFO_REQUEST,
  USER_INFO_FAIL,
  USER_INFO_SUCCESS,
  USER_LOGOUT,
  USER_GOOGLE_TOKEN_SUCCESS,
} from "../actions/types";

const initialState = {
  authToken: localStorage.getItem("authToken"),
  isAuthenticated: false,
  isLoading: false,
  userInfo: null,
  error: null,
};

const userInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_INFO_REQUEST:
      return { ...state, isLoading: true };
    case USER_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        authToken: action.payload.authToken,
        userInfo: action.payload.userInfo,
        isAuthenticated: true,
      };
    case USER_INFO_FAIL:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        error: action.payload.error,
      };
    case USER_GOOGLE_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case USER_LOGOUT:
      localStorage.clear();
      return { ...state, isAuthenticated: false };
    default:
      return state;
  }
};

export default userInfoReducer;
